import { Column } from '@ant-design/plots';
interface IProps {
    value?: any[]
}
const ReservationReportCenterChart = ({ value }: IProps) => {
    const config = {
        data: value,
        xField: 'center',
        yField: 'count',
        colorField: 'status',
        group: true,
        label: {
            position: 'outside',
            formatter: (text: string, datum: any, index: number, data: any) => `${datum.status}\n${text}`
        },
        style: {
            inset: 5,
        },
    };
    return <Column {...config} />;
}

export default ReservationReportCenterChart